<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar granularity="day" @on-selected="onPanelSelect">
            <template slot="leftSide">
              <hierarchy-menu @on-selected="onSelectedDevice"></hierarchy-menu>
            </template>
          </graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <slide-y-up-transition>
          <highcharts v-show="!showEmpty" class="charts" :options="chartOptions" ref="xrangeChart"></highcharts>
          </slide-y-up-transition>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <slide-y-up-transition :duration="200">
        <md-empty-state
          v-show="showEmpty"
          md-icon="check_box_outline_blank"
          :md-label="$lang.titles.no_disconnector_selected"
          :md-description="$lang.messages.choose_disconnector_menu"
        ></md-empty-state>
      </slide-y-up-transition>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import HierarchyMenu from "./components/HierarchyMenu";
import graphToolBar from "@/components/GraphToolBar";

import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";
import format from "date-fns/format";
import rangeChartOptions from "@/config/charts/xrange";
import { SlideYUpTransition } from "vue2-transitions";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar,
    HierarchyMenu,
    SlideYUpTransition
  },

  data() {
    return {
      chartOptions: null,
      dateRange: {},
      devicesGroup: [],
      showEmpty: true,
    };
  },

  created() {
    this.$store.commit("setLoading", true);

    const runtimeLang = this.$lang.charts.runtime;
    const deviceLang = this.$lang.general.device;

    this.chartOptions = JSON.parse(JSON.stringify(rangeChartOptions));
    this.chartOptions.tooltip.formatter = function() {
      return (
        "<b>" +
        this.series.yAxis.categories[this.point.y] +
        "</b><br>" +
        "<b>" +
        deviceLang +
        "</b> " +
        this.point.disconnectorName +
        "<br><b>" +
        runtimeLang +
        "</b> " +
        format(this.point.x, "HH:mm:ss DD/MM/YYYY") +
        " - " +
        format(this.point.x2, "HH:mm:ss DD/MM/YYYY") +
        "<br>"
      );
    };

    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };
  },

  methods: {
    onSelectedDevice(devices) {
      this.devicesGroup = devices;
      if (Object.keys(this.dateRange).length > 0) {
        this.loadChartData();
      }
    },

    onPanelSelect(data) {
      this.dateRange = data.date;
      this.loadChartData();
    },

    loadChartData() {
      const devicesLen = this.devicesGroup.length;

      if (devicesLen > 0) {
        const { chart } = this.$refs.xrangeChart;
        chart.showLoading();
        chart.yAxis[0].setCategories([], false);
        chart.series[0].setData([]);

        this.devicesGroup.forEach((device, index) => {

          this.getRelayNames(device.data.mac).then(relaysName => {
            axios({
              method: "POST",
              url: this.$ENDPOINTS.API_R + "/disconnector/data",
              data: {
                token: getSelectedDeviceToken(device.data.mac),
                from: this.dateRange.from,
                to: this.dateRange.to,
                milliseconds: true
              },
              withCredentials: true
            })
              .then(response => {
                let chartData = [];

                Object.keys(response.data.data).forEach(relay => {
                  const relayName = relaysName["R" + relay.split("_")[1]].name;
                  let categoryIndex = chart.yAxis[0].categories.findIndex(
                    e => e == relayName
                  );

                  response.data.data[relay].forEach(relayData => {
                    if (relayData.state === 1) {
                      if (categoryIndex === -1) {
                        chart.yAxis[0].categories.push(relayName);
                        categoryIndex = chart.yAxis[0].categories.findIndex(
                          e => e == relayName
                        );
                      }

                      chart.series[0].addPoint(
                        {
                          x: relayData.start,
                          x2: relayData.end,
                          y: categoryIndex,
                          energy: 0,
                          duration: 0,
                          disconnectorName: device.title
                        },
                        false,
                        false,
                        false,
                        false
                      );
                    }
                  });
                });

                chart.xAxis[0].setExtremes(null, null, true);
              })
              .catch(error => {
                if (error.response) {
                  if (error.response.data.code == 610) {
                    this.$refs.snackbar.notify(
                      this.$lang.messages.data_not_found
                    );
                    chart.series[0].setData([]);
                  } else {
                    this.$refs.snackbar.notify(
                      this.$lang.messages.api_communication_error
                    );
                  }
                }
              });
          });

          if (index === devicesLen - 1) {
            this.showEmpty = false;
            setTimeout(() => {
              this.$store.commit("setLoading", false);
            }, 300);
          }
        });
      } else {
        this.showEmpty = true;
        this.$store.commit("setLoading", false);
      }
    },

    getAPIData(deviceMAC) {
      const { chart } = this.$refs.xrangeChart;
      chart.showLoading();
      //chart.yAxis[0].setCategories([], false);

      this.getRelayNames(deviceMAC).then(relaysName => {
        axios({
          method: "POST",
          url: this.$ENDPOINTS.API_R + "/disconnector/data",
          data: {
            token: getSelectedDeviceToken(deviceMAC),
            from: this.dateRange.from,
            to: this.dateRange.to,
            milliseconds: true
          },
          withCredentials: true
        })
          .then(response => {
            let chartData = [];

            Object.keys(response.data.data).forEach(relay => {
              const relayName = relaysName["R" + relay.split("_")[1]].name;
              let categoryIndex = chart.yAxis[0].categories.findIndex(
                e => e == relayName
              );

              response.data.data[relay].forEach(relayData => {
                if (relayData.state === 1) {
                  if (categoryIndex === -1) {
                    chart.yAxis[0].categories.push(relayName);
                    categoryIndex = chart.yAxis[0].categories.findIndex(
                      e => e == relayName
                    );
                  }

                  // chartData.push({
                  //   x: relayData.start,
                  //   x2: relayData.end,
                  //   y: categoryIndex,
                  //   energy: 0,
                  //   duration: 0
                  // });

                  chart.series[0].addPoint(
                    {
                      x: relayData.start,
                      x2: relayData.end,
                      y: categoryIndex,
                      energy: 0,
                      duration: 0
                    },
                    false,
                    false,
                    false,
                    false
                  );
                }
              });
            });

            //chart.series[0].setData(chartData, false, false, false);
            chart.xAxis[0].setExtremes(null, null, true);
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.code == 610) {
                this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
                chart.series[0].setData([]);
              } else {
                this.$refs.snackbar.notify(
                  this.$lang.messages.api_communication_error
                );
              }
            }
          });
      });
    },

    getRelayNames(deviceMAC) {
      return axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/disconnector/settings",
        data: {
          token: getSelectedDeviceToken(deviceMAC),
          names: true
        },
        withCredentials: true
      })
        .then(response => {
          return response.data.data;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code == 610) {
              return {
                R1: {
                  name: this.$lang.charts.relay + " 1"
                },
                R2: {
                  name: this.$lang.charts.relay + " 2"
                },
                R3: {
                  name: this.$lang.charts.relay + " 3"
                },
                R4: {
                  name: this.$lang.charts.relay + " 4"
                }
              };
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>